export const TILE_SERVER_URL = "https://api.mapbox.com/styles/v1/mapbox/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
export const TILE_SERVER_ACCESS_TOKEN = "pk.eyJ1IjoicnJleiIsImEiOiJja2J0NW9pdjUwNnBmMzRxeHA2cWZnNHRyIn0.cWo9HR57ya7EtpIJCMgtOw"
export const TILE_STYLE = "streets-v9"